define(["jquery"], function ($) {
    var formPage = {
        init: function () {

            var elements = $("div.field.radio-area input[type=radio]").add($("div.field.checkbox-area input[type=checkbox]"));
            formPage.ToggleAreas(elements);
            elements.click(function () { formPage.ToggleAreas(elements); });

            var select = $("div.field select");
            var selectOptions = select.find("option");
            formPage.ToggleAreas(selectOptions);
            select.click(function () { formPage.ToggleAreas(selectOptions); });
            select.keyup(function () { formPage.ToggleAreas(selectOptions); });

            if ($("#validation-summary").length === 1) {
                window.location = "#validation-summary";
            }

             // Remove-button for uploaded files (after "granska")
            $(".js-remove-file-button").on('click',
                function (e) {
                    e.preventDefault();
                    var currentFileContainer = $(this).parents(".js-current-file");
                    var currentFileBlock = currentFileContainer.parent();
                    var hidden = $(".js-hidden-remove-file", currentFileBlock);
                    var fileInput = $(".js-form-file-input", currentFileBlock).not(".js-has-file");
                    var value;
                    var index = $(this).data("fileindex");

                    if (hidden) {
                        value = hidden.val();
                        if (value) {
                            value += ",";
                        }

                        hidden.val(value + index);
                        currentFileContainer.hide();

                        // If there's no other uploaded files left in the upload block when the current one is removed
                        if ($(".js-current-file:visible", currentFileBlock).length === 0) {

                            fileInput.parent().insertBefore(fileInput.parent().siblings(".js-form-file-add-more"));

                            // If there's no other currently selected files (not yet uploaded) in the upload block
                            if (fileInput.parent().siblings(".js-clientside-current-file:visible").length === 0) {
                                fileInput.show();
                                fileInput.parent().siblings(".js-form-file-add-more").hide();
                            }
                        }
                    }

                    return false;
                });

            $(".js-form-file-input").change(
                function () {
                    if (!isValidFileSize($(this)[0])) {
                        $(this).val("");
                        return;
                    }

                    // If the input element now has a value (i.e, a file was chosen)
                    if ($(this).val()) {
                        $(this).parent().siblings(".js-form-file-add-more").show();

                        if ($(this)[0].files[0]) {
                            var ariaLabelFilename = "Ta bort ";
                            var spanFilename = "";
                            // If there's more than one file selected
                            if ($(this)[0].files.length > 1) {
                                // Add every filename to span
                                for (var i = 0; i < $(this)[0].files.length; i++) {
                                    if (i === 0) {
                                        ariaLabelFilename += $(this)[0].files[i].name;
                                        spanFilename += $(this)[0].files[i].name;
                                    } else {
                                        ariaLabelFilename += ", " + $(this)[0].files[i].name;
                                        spanFilename += ", " + $(this)[0].files[i].name;
                                    }
                                }
                            // Only one file is selected
                            } else {
                                ariaLabelFilename += $(this)[0].files[0].name;
                                spanFilename = $(this)[0].files[0].name;
                            }
                            // Set aria-label and show "Ta bort" button
                            $(this).siblings(".js-clear-file-button").attr("aria-label", ariaLabelFilename).show();
                            // Set text and show span with filename
                            $(this).siblings(".js-clientside-file-name")
                                .text(spanFilename)
                                .show();

                            $(this).addClass("js-has-file");
                            // Hide file input
                            $(this).hide();
                        }

                    } else {
                        if ($(this).siblings(".js-clear-file-button:visible")) {
                            $(this).siblings(".js-clear-file-button").hide();
                        }
                    }

                });

            $(".js-clear-file-button").click(
                function (e) {
                    e.preventDefault();
                    var currentFileContainer = $(this).parents(".js-clientside-current-file");
                    // Show file input
                    $(".js-form-file-input", currentFileContainer).val("").show();
                    $(".js-form-file-input", currentFileContainer).removeClass("js-has-file");
                    // Hide file label
                    $(".js-clientside-file-name", currentFileContainer).hide();

                    var siblingFileContainers = $(this).parent().siblings(".js-clientside-current-file:visible");
                    // If there's other file inputs, with selected or un-selected files, we can remove the current container
                    if (siblingFileContainers.children(".js-form-file-input:visible").length > 0 || siblingFileContainers.children(".js-clientside-file-name:visible").length > 0) {
                        currentFileContainer.remove();
                    } else {
                        $(this).parent().siblings(".js-form-file-add-more").hide();
                    }

                    $(this).hide();
                }
            );

            $(".js-form-cancel-button").click(
                function (e) {
                    if (confirm($("#js-form-cancel-button-text").text())) {
                        return true;
                    }

                    e.preventDefault();
                    return false;
                });

            $(".js-form-file-add-more").click(
                function (e) {
                    e.preventDefault();
                    var input = $(this).siblings(".js-clientside-current-file:last");

                    if (input.is(":visible")) {
                        var clone = input.clone(true);
                        clone.children(".js-form-file-input").val("").show();
                        clone.children(".js-clear-file-button").hide();
                        clone.children(".js-clientside-file-name").val("").hide();
                        clone.insertAfter(input);
                        // Open the select file dialog automatically, instead of having to click again
                        clone.children(".js-form-file-input").click();
                    } else {
                        input.show();
                    }

                    $(this).hide();
                });

            $(".js-hidden-remove-file").val(""); // auto-filled on page reload in Firefox
            $(".js-form-file-input").each(function () {
                // trigger change event (show more button) for auto-filled file inputs after page reload
                if ($(this).val()) {
                    $(this).show();
                    $(this).trigger("change");
                }
            });

            
            if ($('#user-form')) {

                // handle pre-selection from querys in url
                QrLinksHandler.setup();

                // initialize Session Updater on page
                formPage.KeepSessionAlive();
            }

            function bytesToMegabytes(bytes) {
                var mb = bytes / Math.pow(1024, 2);
                return mb.toFixed(2) + " MB";
            }

            function isValidFileSize(inputElem) {
                var oneMB = 1048576;
                var maxAttachedFileSizeSumBytes = parseInt(document.getElementById("maxAttachedFileSizeSum").value) || (10 * oneMB);
                var maxFileSizeBytes = maxAttachedFileSizeSumBytes;
                var maxTotalFileSizeBytes = maxAttachedFileSizeSumBytes;

                var i, file, sum, errorMsg;
                

                if (!window.FileReader) {
                    // file api not supported
                    return true;
                }

                if (inputElem.files.length > 1) {
                    errorMsg = "De senast valda filerna kommer inte att laddas upp.";
                } else {
                    errorMsg = "Den senast valda filen kommer inte att laddas upp.";
                }

                // check this input
                for (i = 0; i < inputElem.files.length; i++) {
                    file = inputElem.files[i];

                    // check for executables
                    if (isExecutableFileExtension(file.name)) {
                        alert('Tyvärr är den här filtypen inte tillåten av säkerhetsskäl');
                        return false;
                    }

                    if (file.size > maxFileSizeBytes) {
                        alert(errorMsg + "\n\nFilen " + file.name + " är " + bytesToMegabytes(file.size) + " stor.\nDet går inte att ladda upp filer större än " + bytesToMegabytes(maxFileSizeBytes) + ".");
                        return false;
                    }
                }

                // sum of all inputs
                sum = 0;
                $(".js-form-file-input").each(
                    function () {
                        var inputElem = $(this)[0];
                        for (i = 0; i < inputElem.files.length; i++) {
                            file = inputElem.files[i];
                            sum += file.size;
                        }
                    });

                $(".js-remove-file-button:visible").each(
                    function () {
                        sum += $(this).data("filesize");
                    });

                if (sum > maxTotalFileSizeBytes) {
                    alert(errorMsg + "\n\nDen sammanlagda storleken på alla filer skulle bli " + bytesToMegabytes(sum) + ".\nDet går inte att ladda upp mer än " + bytesToMegabytes(maxTotalFileSizeBytes) + " sammanlagt.");
                    return false;
                }

                return true;
            }

            function isExecutableFileExtension(name) {
                if (name) {
                    var executables = ['.EXE', '.BAT', '.COM', '.CMD', '.INF', '.IPA', '.OSX', '.PIF', '.RUN', '.WSH', '.PS1', '.PSM1', '.PSD1'];

                    for (var i = 0; i < executables.length; i++) {
                        if (name.toLowerCase().includes(executables[i].toLowerCase())) {
                            return true;
                        }
                    }
                }
                return false;
            }
        },
        ToggleAreas: function (items) {
            items.each(function () {
                var inputId = $(this).data("toggleid");
                var area = $("#" + inputId);
                if (this.checked || this.selected) {
                    area.show();
                }
                else {
                    area.hide();
                    area.find(":checked").prop("checked", false);
                    area.find(":selected").prop("selected", false);
                    area.find("input:text").val("");
                    area.find("textarea").val("");
                }
            });
        },
        KeepSessionAlive: function () {
            var postPath = "keepsessionalive";
            // get current url
            var location = window.location;
            var currentPath = location.pathname;
            var lastSlashIndex = currentPath.length - 1;
            // strip last slash from current path
            currentPath = currentPath[lastSlashIndex] == '/' ? currentPath.substr(0, lastSlashIndex) : currentPath;

            var actionUrl = `${location.protocol}//${location.host}/${currentPath}/${postPath}`;
            // initialize Session Updater on page
            SessionUpdater.Setup(actionUrl);
        }
    };
    return formPage;
});

// keep session alive
SessionUpdater = (function () {
    var keepSessionAliveUrl = null;
    var timeout = 19 * 1000 * 60; // 19 minutes

    function setupSessionUpdater(actionUrl) {
        // store local value
        keepSessionAliveUrl = actionUrl;
        // start timeout - it'll run after n minutes
        checkToKeepSessionAlive();
    }

    // fires every n minutes - if there's been movement ping server and restart timer
    function checkToKeepSessionAlive() {
        setTimeout(function () {
            keepSessionAlive();
        }, timeout);
    }

    function keepSessionAlive() {
        // if we've had any movement since last run, ping the server
        if (keepSessionAliveUrl != null) {
            $.ajax({
                type: "POST",
                url: keepSessionAliveUrl,
                success: function (data) {
                    // restart timeout to check again in n minutes
                    checkToKeepSessionAlive();
                },
                error: function (data) {
                    console.log("Error posting to " & keepSessionAliveUrl);
                }
            });
        }
    }
    // export setup method
    return {
        Setup: setupSessionUpdater
    };
})();

// handles pre-selection on dropdowns by elementIds from url query parameters
QrLinksHandler = (function () {
    var requestedUrl = null;
    var urlQueryParams = {};
    // pre as in prefix
    const removeFromName = 'pre';

    // handles pre-selection from url by picking elements ids from query parameters
    function setupQrLinksHandler() {
        // picks elementIds and value from urlQuerys /?form137487=105&form142141=test
        // removes "form" from urlQuery name

        requestedUrl = window.location.href;
        urlQueryParams = getQueryParams(requestedUrl);

        if (urlQueryParams) {
            for (var queryKey in urlQueryParams) {
                var currentQuery = urlQueryParams[queryKey];
                var queryValue = Array.isArray(currentQuery) ? currentQuery[0] : currentQuery;

                if (queryKey.startsWith(removeFromName) && queryValue.length) {
                    //url-query comes in as preXXXX=value
                    //remove pre from queryName
                    let elementIdStartsWith = queryKey.substring(removeFromName.length);

                    //find elements with ids starting with
                    let $elements = $('[id^="' + elementIdStartsWith + '"]');
                    if ($elements.length) {
                        const $element = $elements.first();

                        // find option with value
                        const hasOption = $element.find('[value="' + queryValue + '"]').length > 0;
                        // only if value exists as option then set value and trigger change
                        if (hasOption) {
                            $element.val(queryValue).change();
                        }
                    }
                }
            }
        }
    }

    // converts querys and values to object
    function getQueryParams(url) {
        var searchParams = new URLSearchParams(url.split('?')[1]);
        var urlParams = {};

        searchParams.forEach((value, key) => {
            if (urlParams[key]) {
                if (!Array.isArray(urlParams[key])) {
                    urlParams[key] = [urlParams[key]];
                }
                urlParams[key].push(value);
            } else {
                urlParams[key] = value;
            }
        });

        return urlParams;
    }
    // export setup method
    return {
        setup: setupQrLinksHandler
    };
})();